module.exports = __webpack_public_path__ + "assets/img/portal-unknown.2b46a961.png";